import {Fancybox} from '@fancyapps/ui';
import {de_DE as de} from '@fancyapps/ui/dist/fancybox/l10n/de_DE';

Fancybox.bind('.gallery a', {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	Carousel: {
		infinite: true,
	},
	l10n: de, // See https://fancyapps.com/fancybox/guides/localization/
});

Fancybox.bind('.floor-plan > p a', {
	l10n: de, // See https://fancyapps.com/fancybox/guides/localization/
});
